import type { SxProps, Theme } from '@mui/material';
import type { Position } from 'common/types/dashboard/dashboardDefinition';

// A 1-row tile is 168px of grid row; the chart takes what the header leaves. Each extra row the
// tile spans adds that row plus the 24px grid gap, so a 2-row chart actually gets taller.
const CHART_BASE_HEIGHT_PX = 200;
const GRID_ROW_STEP_PX = 192;

export const chartHeightPx = (position: Position | undefined): number =>
  CHART_BASE_HEIGHT_PX + (Math.max(position?.h ?? 1, 1) - 1) * GRID_ROW_STEP_PX;

export const chartBodySx: SxProps<Theme> = {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: 0.5,
  minWidth: 0,
};

export const chartMessageSx = (heightPx: number): SxProps<Theme> => ({
  alignItems: 'center',
  color: theme => theme.palette.neutral[500],
  display: 'flex',
  fontSize: 13,
  justifyContent: 'center',
  lineHeight: '18px',
  minHeight: heightPx,
  paddingX: 2,
  textAlign: 'center',
});

export const chartCaptionSx: SxProps<Theme> = {
  color: theme => theme.palette.neutral[500],
  fontSize: 12,
  lineHeight: '16px',
};
